import { type Messages} from "./interfaces/messages";
import {Advisory} from '@ca.vmedia.tv/swagger-api';
import {domain} from "@ca.vmedia.tv/domains";
import {AppConstants} from "@/common";

const messages: Messages = {
    test: "Bonjour, monde!",
    okButton: "Ok",
    backButton: "Arrière",
    error: "Erreur",
    errorBtn: "Quitter maintenant",
    notImplemented: "À venir...",
    appNameVmedia: "VMedia",
    appNameFizzTV: "FizzTV",
    appNameRiverTV: "RiverTV",
    appNameFreedom: "Freedom",
    somethingWentWrong: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    time:{
        shortHour: 'h',
        shortMinute: 'min',
        shortSecond: 'sec'
    },
    login: {
        signin: "Connexion",
        accessAsGuest: "Mode invité",
        forgotPassword: "Mot de passé oublié?",
        next: "Continuer",
        visit: "Visite",
        password: "Mot de passe",
        enterPassword: "Entrer le mot de passe",
        username: "Nom d'utilisateur",
        enterUsername: "Entrer nom d'utilisateur",
        usernameVmedia: "Nom d'utilisateur (ex: 399000000000)",
        usernameRiver: "Nom d'utilisateur (ex: 416000000000)",
        usernameFizzTV: "Nom d'utilisateur (ex: 192000000000)",
        usernameFreedom: "Nom d'utilisateur (ex: 192000000000)",
        enterCredentials:
            "Veuillez entrer votre nom d'utilisateur et votre mot de passe {publisher}.",
        getFreeTrial: "Obtenir l'essai gratuit",
        switchAccount: "Changer de compte",
        errors: {
            invalidCredentials: "Identifiants incorrects",
            invalidLocation: "Les services ne sont pas disponibles à votre location",
            other: "Une erreur s'est produite sur notre serveur",
            networkProblem: "Une erreur s'est produite sur notre serveur",
            noSubscriptions: "Désolé, vous n'avez pas d'abonnement actif",
            notAvailable: "Indisponible"
        },
        restorePasswordUrl: {
            RiverTV: "https://rivertv.ca/forgot/password",
            VMedia: "https://www.vmedia.ca/en/support/password/forgot",
            Freedom: "https://www.vmedia.ca/en/support/password/forgot",
            FizzTV: "https://fizztv.ca/forgot/password"
        },
        forgot: {
            resetPassword: "Réinitialiser le mot de passe",
            visit: "Visite:",
            or: "OU",
            scan: "Scannez le code QR avec l'appareil photo de votre appareil mobile",
        },
        okta: {
            tokenError: {
                title: "Voilà qui est gênant",
                text: "La connexion a échoué. On se reprend, d’accord?",
                button: "OK",
            },
            serverError: {
                title: "Une erreur est survenue",
                text: "Le système a eu un p’tit malaise. Veuillez réessayer",
                button: "OK",
            },
            FizzTV: {
                title: "Pour connecter cet appareil à votre forfait télé Fizz.",
                goToWebsite: "À partir du navigateur de votre choix, visitez:",
                authCode: "Entrez le code d’activation suivant:",
                timer: "Ce code expire dans",
                or: "OU",
                scan: "Avec l’appareil photo de votre téléphone mobile, numérisez ce code QR:",
                footnote: "Cette page se fermera automatiquement une fois l’appareil connecté avec succès.",
                button: "Obtenir un nouveau code"
            },
            Freedom: {
                footnote: "Cette page se fermera automatiquement après une connexion réussie.",
            }
        },
        signIn: {
            title: "Pour vous connecter et activer cet appareil, depuis n'importe quel navigateur",
            enterCode: "Entrer le code d'activation",
            getNewCode: "OBTENIR UN NOUVEAU CODE",
            expiredCode: "Code expiré",
            unavailable: "Ce type de connexion est actuellement indisponible. Veuillez sélectionner un autre type de connexion ou réessayer"
        },
        welcome: {
            firstScreen: {
                title: "Allô, et bienvenue. Allons-y!",
                subtitle: "Pas de forfait Fizz télé encore?",
                infoFirst: `Découvrez notre service de télé en ligne: contenu sur demande et en direct en qualité HD sur l’appareil de votre choix, 
                avec une capacité de cinq (5) visionnements simultanés et plus encore.`,
                infoSecond: "Visitez Fizz.ca/TV pour tous les détails."
            },
            secondScreen: {
                title: "Quelques étapes et vous serez prêt: ",
                firstStep: "Connectez-vous.",
                secondStep: "Suivez les instructions pour connecter cet appareil à votre forfait télé Fizz.",
                thirdStep: "Visionnez votre contenu préféré."
            }
        }
    },
    menu: {
        home: "Accueil",
        guide: "Guide",
        onDemand: "Sur demande",
        settings: "",
        myTv: "Ma Télé",
        search: "",
    },
    devmode: {
        title: "Mode développeur",
        apiEnvironment: {
            title: "Environnement API",
            description: '',
            preview: "Aperçu",
            prod: "Production",
        },
        oktaEnvironment: {
            title: "Environnement Okta",
            description: `Par défaut, cela ne fonctionne qu'avec les points de terminaison de production. Aperçu de l'API Okta OFF`,
            preview: "Aperçu",
            prod: "Production",
        },
        reset: {
            title: "Désactivation du mode développeur",
            description: `Si vous désactivez le mode développeur, tous les paramètres reviendront à leurs valeurs par défaut.`,
            button: "Désactiver"
        }
    },
    settings: {
        title: "Paramètres",
        navigation: {
            account: "Compte",
            subscription: "Manage Subscription",
            favorites: "Chaînes favorites",
            parent: "Contrôle parental",
            privacy: "Politique de vie privée",
            clearCache: "Vider le cache",
            devmode: 'Mode développeur',
            about: {
                VMedia: "À propos de nous",
                RiverTV: "À propos de nous",
                FizzTV: "Philosophie unique",
                Freedom: "À propos de nous"
            },
            player: "Lecteur",
            softwareLicense: "Licence d'utilisation",
            freedomService: "Service Freedom TV, optimisé par VMedia.",
            help: "Aide",
            language: "Langue",
        },
        account: {
            title: "Vous êtes actuellement connecté à ce compte",
            guestUserName: "Invité",
            buttonSignIn: "Connexion",
            buttonSignOut: "Déconnexion",
            modalText: "Êtes-vous certain de vouloir vous déconnecter?",
            modalPositive: "OUI",
            modalNegative: "NON",
            modalClose: "PROCHE",
            modalRetry: "RETENTER"
        },
        version: "Version {0}",
        privacyPolicy: {
            RiverTV: "https://rivertv.ca/devices/privacy-policy-dark-fr",
            VMedia: "https://www.vmedia.ca/fr/devices/support/privacy-policy",
            Freedom: "https://www.vmedia.ca/fr/devices/support/privacy-policy",
            FizzTV: "https://www.vmedia.ca/fr/devices/support/privacy-policy",
            qrTitle: "Scannez le code QR avec l'appareil photo de votre appareil mobile",
        },
        aboutUs: {
            RiverTV: "https://rivertv.ca/devices/about-dark-fr",
            VMedia: "https://www.vmedia.ca/fr/devices/info/about",
            Freedom: "https://www.vmedia.ca/fr/devices/info/about",
            FizzTV: "https://www.vmedia.ca/fr/devices/info/about",
            qrTitle: "Scannez le code QR avec l'appareil photo de votre appareil mobile",
        },
        parentControl: {
            ratings: {
                rating: "Évaluation",
                noRestriction: "Aucune restriction",
                g: "G (Convient à tous les âges)",
                pg: "PG (Surveillance parentale conseillée) ",
                stronglyCautioned: "14+ (Mise en garde aux parents)",
                restricted: "18+ (Ne convient pas aux mineurs)",
            },
            unlockTimes: {
                unlockTime: "PIN temps de déverrouillage",
                askAlways: "Une seule fois",
                oneHour: "Poer 1 heure",
                twoHour: "Poer 2 heures",
                fourHour: "Poer 4 heures",
            },
            reloginTitle: "Veuillez vous connecter pour accéder au Contrôle Parental",
            forgotTitle: `Connectez-vous à votre compte sur ${domain} pour accéder à votre NIP`,
            adultPin: {
                title: "Entrez votre NIP",
                error: "Vous avez entré un NIP incorrect",
                forgot: "Oublié ?"
            }
        },
        favorites: {
            save: "L'enregistrement est terminé",
            error: "Les modifications ne peuvent pas être enregistrées pour certaines raisons",
            search: {
                enterText: "Rechercher un numéro ou un nom de chaîne",
                searchFor: "Recherche de",
                nothingWasFound: "Rien n'a été trouvé.",
                tryDifferentKeyword: "Veuillez essayer différents mots-clés.",
            }
        },
        player: {
            autoplay: "Lecture automatique",
            on: "Activé",
            off: "Désactivé"
        },
        softwareLicense: {
            url: "https://www.freedommobile.ca/en-CA/terms/tv-software-licence-agreement",
        },
        service: {
            text: `Le service Freedom TV est optimisé par VMedia. Freedom Mobile inc. et VMedia inc. sont toutes deux des filiales à 100 % de Vidéotron ltée, 
                une société de communication intégrée active dans les domaines de la télévision, du divertissement, de l’accès à Internet, de la téléphonie 
                filaire et de la téléphonie mobile, dont le siège social est situé à Montréal, au Québec.`,
        },
        help: {
            FizzTV: {
                faqTitle: "FAQ",
                faqDescription: "Trouvez des fiches d’aide et les réponses aux questions les plus fréquentes.",
                forumTitle: "Forum",
                forumDescription: "Échangez des trucs et des astuces avec d’autres membres Fizz.",
                supportTitle: "Équipe Service client",
                supportDescription: "Reliez votre appareil mobile pour clavarder avec notre équipe Service client. Pour ouvrir une conversation",
                visit: "Visitez",
                supportSwitch: {
                    firstInstructions: 'Sélectionnez le type d’appareil que vous utilisez.',
                    secondInstructions: 'Balayez le code QR.',
                    qrCodeLink: '',
                }
            }
        },
        languages: {
            en: "Anglais",
            fr: "Français",
            system: "Système",
        },
        clearCache: {
            btnCaption: "Vider le cache",
            title: "Stockage",
            total: "Total",
            usage: "Utilisé",
            mb: "Mo",
            tooltipeMsg: "Une erreur s'est produite. Veuillez réessayer plus tard.",
        },
    },
    vod: {
        channels: "Chaînes à la demande",
        newReleasedShows: "Spectacles récemment ajoutés",
        newReleasedMovies: "Films récemment ajoutés",
        recommendedShows: "Spectacles recommandés",
        recommendedMovies: "Films recommandés",
        detailGenre: "Genre",
        btnWatchingName: "Regarde maintenant",
        fizzChannels: "Chaînes sur demande",
        mostPopular: "Les plus populaires",
        newReleases: "Nouveautés",
        all: "Tout",
        tvShows: "Émissions télé",
        movies: "Films"
    },
    home: {
        recentChannels: "Chaînes récentes",
        movies: "Films",
        sports: "Des sports",
        kids: "Enfants",
        news: "Actualités",
        live: "En direct",
        exitApp: "Quitter l'application",
        confirmExitApp: "Es tu sûr de vouloir partir?",
        noInternet: "Problème de réseau",
        checkConnection: "Impossible de se connecter au serveur. Veuillez vérifier votre connexion Internet",
        continueWatching: "Continuer à regarder",
        fizzMovies: "Films en direct",
        fizzSports: "Sports en direct",
        fizzKids: "Jeunesse en direct",
        fizzNews: "Nouvelles en direct",
        fizzContinueWatching: "Reprendre le visionnement",
        recentlyOnDemand: "Nouveautés sur demande",
        watchAgain: "Regarder à nouveau",
        trends: "Tendances",
        olympics: "Olympiques",
        liveSeries: "Émissions en direct",
    },
    search: {
        youCanSearch:
            "Entrez du texte pour rechercher...",
        nothingWasFound: "Rien n'a été trouvé.",
        tryDifferentKeyword: "Veuillez essayer différents mots-clés.",
        searchFor: "Recherche de",
        liveTv: "En direct",
        moviesOnDemand: "Films à la demande",
        tvShowsOnDemand: "Émissions à la demande",
        moviesOnDemandFizz: "Films sur demande",
        tvShowsOnDemandFizz: "Émissions sur demande",
        channels: "Chaînes",
        castAndCrew: "Cast & Crew",
        enterText: "Rechercher des titres",
    },
    player: {
        contentNotAvailableTitle: "Contenu non disponible",
        contentNotAvailableMessage: "Ceci n'est pas disponible pour le moment",
        confirmStopPlayingTitle: "Arrête de jouer",
        confirmStopPlayingMessage: "Êtes-vous sûr de vouloir arrêter de jouer ?",
        retryModalMessage: "Le système a eu un p’tit malaise. Veuillez réessayer.",
        retryModalTryButton: "Veuillez réessayer",
        retryModalCancelButton: "Annuler",
        buffering: "Mise en mémoire tampon",

        info: "Description",
        add: "Ajouter à Ma Télé",
        remove: "Ma Télé",
        subtitles: "Sous-titres & Audio",
        play: "Jouer",
        pause: "Pause",
        rewind: "Lecture arrière",
        fastForward: "Lecture avant",
        reset: "Rejouer",
        live: "Aller au DIRECT",
        skipNext: "Prochain épisode",
        skipPrev: "Épisode Précédent",
        functionUnavailable: "Malheureusement, cette fonction est actuellement indisponible pour ce contenu",
        replay: "Rejouer",
        programEnded: `Le programme se termine bientôt... Passage au streaming LIVE dans ${AppConstants.durationForTooltipeMessageProgramEnded} secondes`,
        volume: "Volume",
        channels: "Chaînes",
        subtitlesOnly: "Les sous-titres",
        subtitlesOn: "sur",
        subtitlesOff: "désactivé",
        back: "Grille horaire",
        episodes: "Épisodes",
        errorStartLiveProgram: "Impossible de lancer le direct. Vous pouvez continuer à regarder ou redémarrer le lecteur.",
        errorSwitchChannel: "Une erreur s'est produite lors du changement de chaîne. Veuillez réessayer ultérieurement ou redémarrer le lecteur.",
        errorSwitchProgram: "Une erreur s'est produite lors du changement de programme. Veuillez réessayer ultérieurement ou redémarrer le lecteur.",
        errorSwitchEpisode: "Impossible de changer d'épisode. Veuillez réessayer.",
        errorReconnection: "Connexion rétablie mais échec de mise à jour. Veuillez redémarrer.",
        tooltips: {
            errorOpeningPlayerPage: "Une erreur s'est produite lors de l'ouverture de la page du lecteur. Veuillez réessayer plus tard.",
            errorStartingChannel: "Une erreur s'est produite lors de l'ouverture du démarrage de la chaîne. Veuillez réessayer plus tard.",
        }
    },
    castPage: {
        born: "Naissance",
        relatedTitle: "Les gens recherchent aussi",
    },
    details: {
        btns: {
            add: "Ajouter à Ma Télé",
            play: "Jouer",
            resume: "Continuer",
            remove: "Ma Télé",
            trailer: "Bande-annonce",
            channel: "Options de visionnement", 
            season: "Sélectionnez la saison",
            goToChannel: "Regarder la chaîne"
        },
        castNCrew: {
            title: "Cast & Crew"
        },
        relatedContent: {
            title: "Contenu similaire"
        },
        season: "Saison",
        channelModal: {
            title: "Ce programme est également disponible sur les chaînes présentées ci-dessous",
        },
        liveSportLabel: {
            live: "en direct",
            rebroadCast: "rediffusion",
            upcoming: "à venir",
        },
        tooltips: {
            errorOpeningDetailsPage: "Une erreur s'est produite lors de l'ouverture de la page de détails. Veuillez réessayer plus tard.",
            errorPlayDetailsPage: "Une erreur s'est produite lors de la tentative de lecture du contenu. Veuillez vérifier votre connexion Internet et réessayer."
        }
    },
    myTv: {
        favoriteChannels: "Mes chaînes",
        favoriteOnDemand: "Mon sur demande",
        addFavoriteChannels: "Ajouter mes chaines favorites",
        seeOnDemands: "Mon sur demande",
        myWatchList: "Ma Téle",
        continueWatching: "Continuer à regarder",
        seeProgramsInGuide: "Voir les émissions dans la grille horaire",
    },
    advisory: {
        [Advisory.NR]: "",
        [Advisory.PG1]: "G",
        [Advisory.PG2]: "PG",
        [Advisory.PG3]: "14+",
        [Advisory.PG4]: "18+",
        [Advisory.R]: "18+",
    },
    cards: {
        nowPlaying: "Je joue maintenant",
        todayAt: "Aujourd'hui à",
        tomorrowAt: "Demain à",
        yesterdayAt: "Hier à",
        removed: "Supprimé des favoris",
        at: "à",
    },
    notSupported: {
        text: "Votre appareil n’est pas compatible",
    },
    subtitlesModal: {
        title: "Sous-titres & Audio",
        subtitle: "Sous-titres",
        audio: "Audio",
        off: "Désactivé",
        englishDescribedVideo: "Anglais - Vidéodescription",
        descriptiveAudio: "Audio descriptif",
        originalAudio: "Original",
        closedCaption: "Légende Fermée",
    },
    guide: {
        favoriteChannels: "Chaînes favorites",
        channelFilter: "Filtre de chaînes",
        emptyData: "Aucun contenu disponible pour les filtres de guide TV sélectionnés.",
        emptyDataTitle: "Cet espace est à vous.",
        emptyDataMsg: "Enregistrez vos chaînes favorites sous Ma télé pour les retrouver facilement.",
        emptyDataBtn: "Ajouter des chaînes",
        waiting: "S'il vous plaît, attendez",
        btnWatch: "En direct",
        today: "AUJOURD'HUI",
        yesterday: "HIER",
        tomorrow: "DEMAIN",
        erroreChannelsSegments: "Une erreur s'est produite. Impossible de récupérer les programmes. Veuillez réessayer plus tard.",
        filterTabs: {
            all: 'Tout',
            subscribed: 'Mon forfait',
            favourites: 'Ma télé',
            out_of_home: 'À l’extérieur'
        },
        guideManager: {
            tooltip: "La chaîne {accessNum} n'est pas disponible dans votre liste."
        }
    },
    highDefinition: "HD",
    closedCaptions: "CC",
    showAll: "Voir tout",
    cancelButton: "Annuler",
    previewMode: "Mode invité",
    contentUnavailableSingIn: {
        RiverTV: "Le contenu n'est pas disponible.<br> Connectez-vous à votre compte s'il vous plaît",
        VMedia: "Le contenu n'est pas disponible.<br> Connectez-vous à votre compte s'il vous plaît",
        Freedom: `Il s’agit d’un compte de prévisualisation. Veuillez vous connecter pour accéder à votre compte.<br><br>
                Vous n’êtes pas inscrit au service de télévision Freedom TV? Inscrivez-vous dès maintenant.<br><br>
                Dans certaines régions, et avec un forfait Internet résidentiel Freedom admissible, vous avez la possibilité d’ajouter le service de télévision Freedom TV.<br><br>
                Restez à l’affût pour connaître les régions dans lesquelles nous étendons nos services!`,
        FizzTV: "Le contenu n'est pas disponible.<br> Connectez-vous à votre compte s'il vous plaît"
    },
    reloadModal: {
        title: "Redémarrer l'application",
        message: "Pour appliquer les changements, vous devez redémarrer l'application.",
        btnConfirm: "Redémarrer maintenant",
        btnCancel: "Plus tard"
    },
    vizitOne: {
        urlTitle: "Visite:",
        or: "OR",
        qrTitle: "Scannez le code QR avec l'appareil photo de votre appareil mobile",
    },
    maintenanceModal: {
        title: "Maintenance",
        player: {
            message: "Nous sommes en cours de maintenance. Soyez patient. Vous pouvez continuer à regarder la lecture en cours.",
            btn: "Ok"
        },
        global: {
            message: "Nous sommes en cours de maintenance. Soyez patient. Nous vérifierons automatiquement la disponibilité dans",
            btnDisabledMessage: "Le prochain essai sera disponible dans",
            btnEnabledMessage: "Essayer à nouveau.",
        },
    },
    youtubeError: {
        default: "La bande-annonce est temporairement indisponible. Essayez de nouveau plus tard."
    },
    fatalError: "Une erreur s’est produite lors de l’exécution de l’application. Veuillez cliquer sur « Quitter maintenant » et redémarrer l’application.",
    chunkError: "Une erreur s’est produite lors du chargement d’un module. Veuillez cliquer sur « Quitter maintenant » et redémarrer l’application."
};

export default messages;
